import React from 'react';
import { useState, useEffect } from 'react';
import { Alert, Card, CardContent, TextField, MenuItem, Select } from '@mui/material';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';
import { showNotification } from '../../../redux/slices/notificationSlice';
import CustomButton from '../../../componentsII/Buttons';
import api from '../../../axios/api';

const schema = yup.object().shape({
  vehicleTypeName: yup
    .string()
    .required('vehicle Type name is required')
    .min(2, 'Vehicle Type name must be at least 2 characters long')
    .max(50, 'Vehicle Type name must be less than 50 characters')
    .trim()
});

const AddUpdateVehicleModal = ({ refetch, onClose, vehicleTypeId = null, initialData = null }) => {
  const dispatch = useDispatch();
  
  // Form states
  const [vehicleTypeName, setVehicleTypeName] = useState(initialData?.type_name || '');

  // UI states
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({
   vehicleTypeName: ''
  });

  const validateForm = async () => {
    try {
      await schema.validate({ 
        vehicleTypeName
      }, { abortEarly: false });
      return true;
    } catch (err) {
      const newErrors = {};
      err.inner.forEach((error) => {
        newErrors[error.path] = error.message;
      });
      setErrors(prevErrors => ({
        ...prevErrors,
        ...newErrors
      }));
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({vehicleTypeName:'' });

    const isValid = await validateForm();
    if (!isValid) return;

    try {
      setIsSubmitting(true);


      const payload = {
        vehicleTypeId: vehicleTypeId || 0,
        vehicleTypeName: vehicleTypeName.trim(),
      };

      const response = await api.post('/admin/createUpdateVehicleType', payload);
      
      if (response.data.status === '200') {
        dispatch(showNotification({ 
          message: response.data.message, 
          type: "success" 
        }));
        onClose();
        refetch();
      } else {
        setErrors(prev => ({
          ...prev,
          general: response.data.message || 'Something went wrong'
        }));
      }
    } catch (err) {
      setErrors(prev => ({
        ...prev,
        general: err.message || 'An error occurred while saving'
      }));
      dispatch(showNotification({ 
        message: err.message || 'An error occurred', 
        type: "error" 
      }));
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <Card className="w-full mx-auto">
    <CardContent>
      <form onSubmit={handleSubmit} className="space-y-4">

        <div className="space-y-2">
          <label htmlFor="subIndustryName" className="text-sm font-medium">
            Vehicle Type Name
          </label>
          <TextField
            id="vehicleTypeName"
            value={vehicleTypeName}
            onChange={(e) => setVehicleTypeName(e.target.value)}
            placeholder="Enter sub-industry name"
            disabled={isSubmitting}
            size="small"
            error={Boolean(errors.vehicleTypeName)}
            className="w-full"
          />
          {errors.vehicleTypeName && (
            <p className="text-sm text-red-500 mt-1">{errors.vehicleTypeName}</p>
          )}
        </div>

        <div className="flex justify-end gap-5 items-center mt-5">
          <CustomButton
            className="bg-gray-500 hover:bg-gray-700 text-white"
            text="Cancel"
            click={onClose}
            disabled={isSubmitting}
          />
          <CustomButton
            className="bg-green-600 hover:bg-green-700 text-white"
            text={vehicleTypeId ? "Update" : "Submit"}
            type="submit"
            disabled={isSubmitting}
          />
        </div>
      </form>
    </CardContent>
  </Card>
  )
}

export default AddUpdateVehicleModal